import api from "../axios";

export async function changeMyPassword(currentPassword, newPassword) {
  try {
    const response = await api.post(`/auth/change-my-password`, {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
}

export async function updateMyProfile(nome, email, phone) {
  try {
    const response = await api.post(`/auth/update-my-profile`, {
      nome,
      email,
      phone,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
}

export async function getMyProfile() {
  try {
    const response = await api.get(`/users/me`);
    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
}

export async function getAllUsers(page, perPage, needle) {
  try {
    const response = await api.get(`/users/all`, {
      params: {
        page,
        perPage,
        needle,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

export async function getUserById(id) {
  try {
    const response = await api.get(`/users/byId/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    throw error;
  }
}

export async function createUser(
  username,
  name,
  email,
  roles,
  phone,
  password,
  gestor,
  cnpj,
  sendPassword = false,
  tipo = null
) {
  try {
    const response = await api.post(`/auth/create-user`, {
      username,
      name,
      email,
      roles,
      phone,
      password,
      gestor,
      cnpj,
      sendPassword,
      tipo,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
}

export async function updateUser(
  id,
  username,
  name,
  email,
  phone,
  roles,
  password,
  gestor,
  cnpj,
  tipo = null
) {
  try {
    const response = await api.put(`/users/update/${id}`, {
      username,
      name,
      email,
      roles,
      phone,
      password,
      gestor,
      cnpj,
      tipo,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
}

export async function deleteUser(id) {
  try {
    const response = await api.delete(`/users/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
}

export async function getGestores() {
  try {
    const response = await api.get(`/users/gestores`);
    return response.data;
  } catch (error) {
    console.error("Error fetching gestores:", error);
    throw error;
  }
}
